import angular from "angular";

let ReportsFactory = angular
  .module("ReportsFactory", [])
  .factory("ReportsFactory", ($rootScope, $http, HttpFactory, URLS) => {
    "ngInject";
    const STATISTIC_REPORTS_ENUM = {
      PLAYER_REGISTER: 1,
      TEAM_REGISTER: 2,
      REGISTERED_REGISTER: 3,
      MATCHES_WITH_ENTRIES: 4,
      LEAGUES_ENTRIES: 5,
      TEAM_PLAYERS: 6,
      PLAYER_LEAGUE: 7,
      MULTIWIN: 8,
      TRAINING_ENTRIES: 9,
      PLAYER_LEAGUE_UNIQUE: 10,
      GGA_PLAYERS: 11,
      GGA_TEAMS: 12,
      MEDALS: 13,
    };
    const PAYMENTS_REPORTS_ENUM = {
      TEAM: 1,
      PLAYER: 2,
    };
    return {
      STATISTIC_REPORTS: STATISTIC_REPORTS_ENUM,
      PAYMENTS_REPORTS_ENUM: PAYMENTS_REPORTS_ENUM,
      statistics: (reportEnum, year, data) => {
        let url = HttpFactory.buildUrl(URLS.REPORTS_STATISTICS, {
          year: year,
          report: reportEnum,
        });

        /* data =>
			matches (array)
			*/
        return HttpFactory.getPDF(url, data);
      },
      payments: (reportEnum, data) => {
        let url = HttpFactory.buildUrl(URLS.REPORTS_PAYMENTS, {
          report: reportEnum,
        });

        /* data =>
			paymentIds (array)
			teamId int
			playerId int
			dateFrom Date
			dateTo Date
			*/
        return HttpFactory.getPDF(url, data);
      },
      playerMatchQualification: (matchId, playerId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_PLAYER_QUALIFICATION, {
          matchId: matchId,
          playerId: playerId,
        });

        return HttpFactory.getPDF(url);
      },
    };
  }).name;

export default ReportsFactory;



// WEBPACK FOOTER //
// ./client/app/services/reports.factory.js